import React, { useState, useEffect } from "react";
import StatusBadge from "./components/StatusBadge";
import { getRefundHistoryAPI } from "../../../../api/index";
import { useAuth } from "../../../../hooks/useAuth";
import "./RefundHistory.css";

const RefundHistory = () => {
  const { user } = useAuth();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const itemsPerPage = 6;

  useEffect(() => {
    const fetchRefundHistory = async () => {
      setLoading(true);
      setError(null);

      // ✅ 맨 처음에 로그인 상태 체크 (API 호출 전에)
      if (!user?.id) {
        const mockRefundHistory = [
          {
            id: 1,
            amount: 80000,
            status: "APPROVED",
            created_at: "2025-08-19T15:30:00.000Z",
          },
          {
            id: 2,
            amount: 150000,
            status: "PENDING",
            created_at: "2025-08-18T11:20:00.000Z",
          },
          {
            id: 3,
            amount: 30000,
            status: "REJECTED",
            created_at: "2025-08-17T13:45:00.000Z",
          },
        ];

        setData(mockRefundHistory);
        setTotalPages(1);
        setLoading(false);
        return; // ✅ 여기서 완전 종료 (API 호출 안 함)
      }

      // ✅ 여기까지 오면 로그인 상태이므로 API 호출
      // ✅ 로그인했으면 실제 API 호출
      try {
        const response = await getRefundHistoryAPI({
          page: currentPage,
          pageSize: itemsPerPage,
          web_member_id: user.id,
        });

        setData(response.data.list || []);
        setTotalPages(Math.ceil((response.data.total || 0) / itemsPerPage));
      } catch (err) {
        console.error("환불내역 에러:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchRefundHistory();
  }, [currentPage, itemsPerPage, user?.id]);

  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  if (loading) {
    return (
      <div className="refund-history-container">
        <div className="history-header">
          <h3 className="history-title">환불 내역</h3>
        </div>
        <div>로딩 중...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="refund-history-container">
        <div className="history-header">
          <h3 className="history-title">환불 내역</h3>
        </div>
        <div>에러가 발생했습니다: {error}</div>
      </div>
    );
  }

  return (
    <div className="refund-history-container">
      <div className="history-header">
        <h3 className="history-title">환불 내역</h3>
        <div className="pagination-controls">
          <button onClick={handlePrevPage} disabled={currentPage === 1}>
            &lt;
          </button>
          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
          >
            &gt;
          </button>
        </div>
      </div>
      <ul className="history-list">
        {data.map((item, index) => (
          <li key={item.id || index} className="history-item">
            <div className="item-details">
              <span className="item-date">
                {new Date(item.created_at).toLocaleDateString("ko-KR")}
              </span>
              <span className="item-amount">
                {item.amount?.toLocaleString("ko-KR") || "0"} 원
              </span>
            </div>
            <StatusBadge status={item.status} type="refund" />
          </li>
        ))}
      </ul>
      {data.length === 0 && (
        <div className="no-data-message">환불내역이 없습니다.</div>
      )}
    </div>
  );
};

export default RefundHistory;
